export default "__VITE_PUBLIC_ASSET__4a2bcf23__"